<template>
  <div class="table-wrapper">
    <div class="table-header">
      <div class="table__search-input-wrapper">
        <input
          type="text"
          class="table__search-input"
          placeholder="Search..."
          v-model="queryString"
        />
        <search-icon />
      </div>
    </div>

    <table class="custom-table responsive-table">
      <thead>
        <tr>
          <th>Location Name</th>
          <th>Employees</th>
          <th>Address</th>
          <th>City</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="!loading && !filteredLocations.length">
        <tr>
          <td></td>
          <td></td>
          <td>
            No locations found!
          </td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
      <tbody v-if="locations">
        <tr v-for="location in filteredLocations" :key="location.id">
          <td>{{ location.locationName }}</td>
          <td>-</td>
          <td>{{ location.address }}</td>
          <td>{{ location.city }}</td>
          <td
            tabindex="-1"
            @blur="selectedRowId = null"
            class="table__action-btn cursor-pointer"
          >
            <span @click="showActionOptions(location.id)">
              <vertical-ellipsis />
            </span>
            <div
              class="table__action-options"
              v-if="selectedRowId == location.id"
            >
              <div
                class="table__action-option cursor-pointer"
                @click="viewLocation(location.id)"
              >
                <p>View</p>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <loader v-if="loading" />

    <pagination />
 
  </div>
</template>

<script>
import Pagination from "@/components/UI/pagination";
// import ViewLocationModal from "./ViewLocationModal";

export default {
  components: {
    Pagination,
    // ViewLocationModal,
  },
  data() {
    return {
      selectedRowId: null,
      isLocationModal: false,
      locations: [],
      loading: true,
      singleLocationId: "",
      queryString: "",
    };
  },
  computed: {
    filteredLocations() {
      return this.filterArray(this.locations, this.queryString);
    },
  },
  mounted() {
    this.getAllLocations();
  },
  methods: {
    async getAllLocations() {
      this.loading = true;
      try {
        let response = await this.$_getAll3plLocations();
        console.log(response);
        this.locations = response.data.findLocation;
        this.loading = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    viewLocation(locationId) {
      this.singleLocationId = locationId;
      this.isLocationModal = true;
    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  margin: 3rem 0;
}
.table-header {
  display: flex;
  justify-content: flex-end;
}
.table__btn {
  padding: 0.45rem 0.85rem;
  color: #ffffff;
  font-size: 0.85rem;
  border-radius: 3px;
}
.table__search-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 30vw;
  border-radius: 15px;
  padding: 0 1rem;
  margin-right: 1.5rem;
}
.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}
.table__search-input:focus {
  outline: none;
}
.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}
.custom-table {
  margin: 2rem 0;
  width: 100%;
}
.custom-table tr {
  border-bottom: 1px solid #d5d5d5;
}
.custom-table th {
  color: #060e18;
  font-weight: 600;
}
.custom-table th,
td {
  padding: 1rem;
  font-size: 0.9rem;
}
.custom-table td {
  color: #343633;
}
.table__action-btn {
  position: relative;
  padding: 0;
  /* display: flex;
  height: 100%;
  justify-content: center;
  align-items: center; */
}
.table__action-options {
  position: absolute;
  width: 8rem;
  /* height: 7rem; */
  padding: 0.5rem 0;
  right: 2rem;
  background: #ffffff;
  z-index: 999;
  border-radius: 3px;
  box-shadow: 0px 0px 12px #dee0e7;
}
.table__action-option {
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
}
.table__action-option:hover {
  background: #fce4da;
}
.table__action-btn span {
  width: 100%;
}
</style>
